import { MODAL_TYPES } from '../../../common/constants'
import { getFilteredProject } from '../utils'

export const getModalPayloads = (modalType, project, id) => {
    const { DELETE_MODAL, OFFER_BASE_MODAL } = MODAL_TYPES
    const selectedProject = project ? [getFilteredProject(project)] : []

    // add other modal payloads as needed
    switch (modalType) {
        case DELETE_MODAL:
            return {
                modalType: DELETE_MODAL,
                modalProps: {
                    id: +id,
                    callbackId: 'delete-project',
                    appModule: 'project'
                },
            }
        case OFFER_BASE_MODAL:
            return {
                modalType: OFFER_BASE_MODAL,
                modalProps: {
                    items: selectedProject,
                    offerType: 'project',
                },
            }
        default:
            return null
    }
}
